export const defaultLocale = 'en-us';
export const defaultTimeZoneId = 'UTC';
const rightToLeftLocales = ['he-il', 'ar-il'];
export const isRightToLeft = (locale) => rightToLeftLocales.includes(locale.toLowerCase());
export const isAmPm = (locale) => new Intl.DateTimeFormat(locale, { hour: '2-digit', minute: '2-digit' }).resolvedOptions().hour12;
export const getDeviceTimeZoneId = () => {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || defaultTimeZoneId;
    }
    catch (e) {
        console.warn('Could not resolve Intl user timezone');
        return defaultTimeZoneId;
    }
};
export const getLocale = (locale) => locale || defaultLocale;
export const isRtlLanguage = (language = DEFAULT_LANGUAGE) => ['ar', 'arc', 'dv', 'fa', 'ha', 'he', 'khw', 'ks', 'ku', 'ps', 'ur', 'yi'].includes(language);
export const DEFAULT_LANGUAGE = 'en';
export const isLanguageBabelSupported = (language) => SUPPORTED_BABEL_LANGUAGES.includes(language);
export const SUPPORTED_BABEL_LANGUAGES = [
    'ar',
    'bg',
    'ca',
    'cs',
    'da',
    'de',
    'el',
    'en',
    'es',
    'fi',
    'fr',
    'he',
    'hi',
    'hr',
    'hu',
    'id',
    'it',
    'ja',
    'ko',
    'lt',
    'lv',
    'ms',
    'nl',
    'no',
    'pl',
    'pt',
    'ro',
    'ru',
    'sk',
    'sl',
    'sv',
    'th',
    'tl',
    'tr',
    'uk',
    'vi',
    'zh',
];
//# sourceMappingURL=locale.js.map